import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Container,
  useMediaQuery,
  Box,
  Button,
  TextareaAutosize,
  MenuItem,
  TextField,
  InputLabel,
  OutlinedInput,
  CircularProgress,
} from "@mui/material";
import "../../styles/inputBox.css";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import CurrentLocationIcon from "../../assets/images/CandidateIcon/current-location-color.svg";
import { getRequest, postRequest, putRequest } from "../../api/apiServices";
import {
  getCandidateByJob,
  getCompanyJob,
  jobSummaryList,
  updateCandidate,
} from "../../api/apiList";
import { useParams } from "react-router-dom";
import ConfirmationDialog from "../DailogBox";
import { generateTextObject } from "../../utils/AIGenerateText";
import LoadingOverlay from "../../utils/LoadingOverlay";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import { companyJobList } from "../../store/jobSlice";
import {
  LocalizationProvider,
  DateTimePicker,
  DatePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";

interface CandidateSpeFirstProps {
  onNext: () => void; // Function to navigate to the next component
  setCandidateData: (data: any) => void;
  initialData: any;
  mode: any;
}

interface GeneratedTextResponse {
  [key: string]: string;
}

const CandidateSpeFirst: React.FC<CandidateSpeFirstProps> = ({
  onNext,
  setCandidateData,
  initialData,
  mode,
}: CandidateSpeFirstProps) => {
  const isMobile = useMediaQuery("(max-width:578px)");
  const [position, setPosition] = useState("");
  const isTabs = useMediaQuery("(max-width:1200px)");

  // Use Store
  const dispatch: AppDispatch = useDispatch<AppDispatch>();

  // declare form fields
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [jobPosition, setJobPosition] = useState("");
  const [rolesResponsibilities, setRolesResponsibilities] = useState("");
  const [opportunities, setOpportunities] = useState("");
  const [salaryExpectation, setSalaryExpectation] = useState("");
  const [salaryRange, setSalaryRange] = useState("");
  const [jobBenifits, setJobBenifits] = useState("");
  const [startExtended, setStartExtended] = useState<Dayjs | null>(null);
  const [commitments, setCommitments] = useState("");
  const [loading, setLoading] = useState(false);

  //params
  const params = useParams();

  const [errors, setErrors] = useState({
    name: "",
    phone: "",
    email: "",
    jobPosition: "",
    rolesResponsibilities: "",
    opportunities: "",
    salaryExpectation: "",
    salaryRange: "",
    jobBenifits: "",
    commitments: "",
  });

  const formIsValid = () => {
    const newErrors = {
      name: !name?.trim() ? "Name is required" : "",
      phone: !phone?.trim() ? "Phone Number is required" : "",
      email: !email?.trim() ? "Email is required" : "",
      jobPosition: !jobPosition ? "Job Position is required" : "",
      rolesResponsibilities: !rolesResponsibilities?.trim()
        ? "Current Role and Responsibilities is required"
        : "",
      opportunities: !opportunities?.trim() ? "Opportunities is required" : "",
      salaryExpectation: !salaryExpectation?.trim()
        ? "Salary Expectation is required"
        : "",
      salaryRange: !salaryRange?.trim() ? "Salary Range is required" : "",
      jobBenifits: !jobBenifits?.trim()
        ? "Benefits Are Important To You In A Job is required"
        : "",
      commitments: !commitments?.trim()
        ? "Obstacles Or Commitments is required"
        : "",
    };

    setErrors(newErrors);

    return Object.values(newErrors).every((error) => error === "");
  };

  useEffect(() => {
    dispatch(companyJobList());
    if (initialData) {
      setName(initialData?.name);
      setPhone(initialData?.phone);
      setEmail(initialData?.email);
      setJobPosition(initialData?.jobPosition);
      setRolesResponsibilities(initialData?.rolesResponsibilities);
      setOpportunities(initialData?.opportunities);
      setSalaryExpectation(initialData?.salaryExpectation);
      setSalaryRange(initialData?.salaryRange);
      setJobBenifits(initialData?.jobBenifits);
      setStartExtended(dayjs(initialData?.startExtended));
      setCommitments(initialData?.commitments);
    }
  }, []);

  useEffect(() => {
    if (initialData) {
      setName(initialData?.name || "");
      setPhone(initialData?.phone || "");
      setEmail(initialData?.email || "");
    }
  }, [initialData]);

  const getCompanyJob = useSelector((state: RootState) => state.companyJob);

  
  useEffect(() => {
    if (getCompanyJob.length > 0 && initialData.jobPosition) {
      const selectedJob = getCompanyJob.find(
        (job) => job.id.toString() === initialData.jobPosition.toString()
      );
      if (selectedJob) {
        setJobPositionName(selectedJob.jobTitle);
      }
    }
  }, [getCompanyJob]);

  const handlePosition = (event: SelectChangeEvent) => {
    setPosition(event.target.value as string);
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    let isoStartExtended = "";

    if (startExtended && dayjs(startExtended).isValid()) {
      isoStartExtended = dayjs(startExtended).toISOString();
    }

    const data = {
      name,
      phone,
      email,
      jobPosition,
      rolesResponsibilities,
      opportunities,
      salaryExpectation,
      salaryRange,
      jobBenifits,
      startExtended: isoStartExtended,
      commitments,
    };
    if (formIsValid()) {
      if (mode) {
        setLoading(true);
        const response = await putRequest(updateCandidate(params?.id), data);
        setCandidateData(response?.data?.data);
        setLoading(false);
        onNext();
      } else {
        const allData = {
          ...initialData,
          ...data,
        };
        setCandidateData(allData);
        onNext();
      }
    }
  };

  // For Timing
  const [titleTimer, setTitleTimer] = useState<NodeJS.Timeout | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [foundCandidateData, setFoundCandidateData] = useState<any>(null);
  const [aiLoading, setAiLoading] = useState(false);

  // Creae A Method to handle The Data
  const handleCandidateJob = (e: any) => {
    e.preventDefault();
    const selectedJob = e.target.value;

    if (selectedJob !== "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        jobPosition: "",
      }));
    }
    const selectedCompanyJob = getCompanyJob.find(
      (job) => job.id === selectedJob
    );
    if (selectedCompanyJob) {
      setJobPositionName(selectedCompanyJob?.jobTitle);
      setJobPosition(selectedCompanyJob.id.toString());
    }
    const findJob = getCompanyJob.filter((job) => job.id === selectedJob);
    const jobTitle = findJob[0]?.jobTitle;
    if (!mode) {
      if (titleTimer) {
        clearTimeout(titleTimer);
      }

      setTitleTimer(
        setTimeout(async () => {
          try {
            const response = await postRequest(getCandidateByJob, {
              id: selectedJob,
            });
            if (response?.status === 200 && response?.data) {
              setFoundCandidateData(response?.data?.data);
              setOpenDialog(true);
            } else {
              setAiLoading(true);
              const object = {
                workingHours: [
                  // `Title : ${jobTitle} Question : What are your expectations regarding working hours and flexibility in this role?`,
                  `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "What are your expectations regarding working hours and flexibility in this role?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
                ],
                educationalBackground: [
                  `You are an expert career assistant AI. Your task is to generate an accurate and concise response for a given job title based on a specific question.  
 
**Question:** "What is your educational background, and how does it relate to this position?"  
**Job Title:** ${jobTitle}  
 
### **Expected Output Format:**  
- **Education:** A list of commonly required degrees or qualifications relevant to the given job title.  
- The response must be well-structured and should not be cut off mid-sentence. Ensure complete sentences within the token limit.  
- Output example for "Software Developer":  
  🔹 B.Tech CSE | BSc Computer Science | M.Tech CSE | BCA | MCA  
 
### **Instructions:**  
- Generate a response that fits within 300 tokens without cutting off mid-sentence.  
- Ensure the list includes **only the most relevant educational qualifications** for the given job title.  
- Keep the response concise and structured as a list with bullet points.  `,
                ],
                courceCertificates: [
                  // `Title : ${jobTitle} Question : Have you pursued any relevant courses or certifications
                  //       recently?`,
                  `You are an expert career assistant AI. Your task is to generate a concise and structured response for a given job title based on a specific question.  
 
**Question:** "Have you pursued any relevant courses or certificates recently?"  
**Job Title:** ${jobTitle}  
 
### **Expected Output Format:**  
- **Courses:** A list of commonly relevant courses or certifications for the given job title.  
- The response must be well-structured and should not be cut off mid-sentence. Ensure complete sentences within the token limit.  
- Output example for "Software Developer":  
  🔹 Data Structures & Algorithms (DSA) | Object-Oriented Programming (OOPs) | Database Management System (DBMS) | Operating Systems (OS) | Computer Networks (CN)  
 
### **Instructions:**  
- Generate a response that fits within 300 tokens without cutting off mid-sentence.  
- Ensure the list includes **only the most relevant courses or certifications** for the given job title.  
- Keep the response concise and formatted as a list with bullet points.  `,
                ],
                technicalSkills: [
                  // `Title : ${jobTitle} Question : What technical skills or expertise do you bring to this role?`,
                  `You are an expert career assistant AI. Your task is to generate a concise and structured response for a given job title based on a specific question.  
 
**Question:** "What technical skills or expertise do you bring to this role?"  
**Job Title:** ${jobTitle}
 
### **Expected Output Format:**  
- **Skills:** A list of commonly required technical skills relevant to the given job title.  
- The response must be well-structured and should not be cut off mid-sentence. Ensure complete sentences within the token limit.  
- Output example for "Software Developer":  
  🔹 Programming (Python, Java, C++) | Data Structures & Algorithms (DSA) | Database Management (SQL, NoSQL) | System Design & Architecture | Version Control (Git, GitHub)  
 
### **Instructions:**  
- Generate a response that fits within 300 tokens without cutting off mid-sentence.  
- Ensure the list includes **only the most relevant technical skills** for the given job title.  
- Keep the response concise and formatted as a list with bullet points.  `,
                ],
                deadlines: [
                  `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "How do you handle stress and tight deadlines?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
                ],
                commonGoal: [
                  `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "Describe a situation where you had to collaborate with a diverse team to achieve a common goal."  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
                ],
                workplace: [
                  `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "Can you share an example of when you had to navigate a difficult conversation or conflict in the workplace?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
                ],
                teamMembersColleague: [
                  `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "How would you describe yourself as a team member and a colleague?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
                ],
                motivates: [
                  // `Title : ${jobTitle} Question : What motivates you to excel in your work?`,
                  `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "What motivates you to excel in your work?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
                ],
                responsibilitiesChallenges: [
                  // `Title : ${jobTitle} Question : Can you describe your ideal job in terms of responsibilities and challenges?`,
                  `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "Can you describe your ideal job in terms of responsibilities and challenges?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
                ],
                projects: [
                  `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "What kind of projects or tasks bring out the best in you professionally?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
                ],
                newOrganization: [
                  `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "What factors are most important to you when considering a new organization?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
                ],
                companyMission: [
                  `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "How do you align with our company's values and mission?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
                ],
                jobFactores: [
                  `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "What factors are crucial for you when choosing a new job?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
                ],
                preferenceCultureGrowthCompensation: [
                  `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "How do you prioritize between company culture, career growth, and compensation?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
                ],
              };
              const data = (await generateTextObject(
                object
              )) as GeneratedTextResponse;
              initialData.workingHours = data?.workingHours;
              initialData.courceCertificates = data?.courceCertificates;
              initialData.educationalBackground = data?.educationalBackground;
              initialData.technicalSkills = data?.technicalSkills;
              initialData.deadlines = data?.deadlines;
              initialData.workplace = data?.workplace;
              initialData.commonGoal = data?.commonGoal;
              initialData.teamMembersColleague = data?.teamMembersColleague;
              initialData.motivates = data?.motivates;
              initialData.responsibilitiesChallenges =
                data?.responsibilitiesChallenges;
              initialData.projects = data?.projects;
              initialData.newOrganization = data?.newOrganization;
              initialData.companyMission = data?.companyMission;
              initialData.jobFactores = data?.jobFactores;
              initialData.preferenceCultureGrowthCompensation =
                data?.preferenceCultureGrowthCompensation;
              setAiLoading(false);
            }
          } catch (error) {
            console.error("Error in handleCandidateJob:", error);
          }
        }, 3000)
      );
    }
  };

  const handleDialogConfirm = () => {
    if (foundCandidateData) {
      setRolesResponsibilities(foundCandidateData?.rolesResponsibilities);
      setOpportunities(foundCandidateData?.opportunities);
      setSalaryExpectation(foundCandidateData?.salaryExpectation);
      setSalaryRange(foundCandidateData?.salaryRange);
      setJobBenifits(foundCandidateData?.jobBenifits);
      setStartExtended(dayjs(foundCandidateData?.startExtended));
      setCommitments(foundCandidateData?.commitments);
      initialData.workingHours = foundCandidateData?.workingHours;
      initialData.project = foundCandidateData?.project;
      initialData.specificChallenges = foundCandidateData?.specificChallenges;
      initialData.currentResponsibilities =
        foundCandidateData?.currentResponsibilities;
      initialData.educationalBackground =
        foundCandidateData?.educationalBackground;
      initialData.courceCertificates = foundCandidateData?.courceCertificates;
      initialData.technicalSkills = foundCandidateData?.technicalSkills;
      initialData.previousPositionTechnicalSkills =
        foundCandidateData?.previousPositionTechnicalSkills;
      initialData.deadlines = foundCandidateData?.deadlines;
      initialData.commonGoal = foundCandidateData?.commonGoal;
      initialData.workplace = foundCandidateData?.workplace;
      initialData.teamMembersColleague =
        foundCandidateData?.teamMembersColleague;
      initialData.motivates = foundCandidateData?.motivates;
      initialData.responsibilitiesChallenges =
        foundCandidateData?.responsibilitiesChallenges;
      initialData.ambitionsGrowthPath = foundCandidateData?.ambitionsGrowthPath;
      initialData.projects = foundCandidateData?.projects;
      initialData.newOrganization = foundCandidateData?.newOrganization;
      initialData.companyMission = foundCandidateData?.companyMission;
      initialData.jobFactores = foundCandidateData?.jobFactores;
      initialData.preferenceCultureGrowthCompensation =
        foundCandidateData?.preferenceCultureGrowthCompensation;
      initialData.interviewedOtherCompanies =
        foundCandidateData?.interviewedOtherCompanies;
    }
    setOpenDialog(false);
  };

  const [jobPositionName, setJobPositionName] = useState(
    "Please select job position"
  );
  const handleDialogCancel = async () => {
    setOpenDialog(false);
    const findJob = getCompanyJob.filter(
      (job) => job.id.toString() === jobPosition.toString()
    );
    const jobTitle = findJob[0]?.jobTitle;
    if (!mode) {
      setAiLoading(true);
      const object = {
        workingHours: [
          // `Title : ${jobTitle} Question : What are your expectations regarding working hours and flexibility in this role?`,
          `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "What are your expectations regarding working hours and flexibility in this role?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
        ],
        educationalBackground: [
          `You are an expert career assistant AI. Your task is to generate an accurate and concise response for a given job title based on a specific question.  
 
**Question:** "What is your educational background, and how does it relate to this position?"  
**Job Title:** ${jobTitle}  
 
### **Expected Output Format:**  
- **Education:** A list of commonly required degrees or qualifications relevant to the given job title.  
- The response must be well-structured and should not be cut off mid-sentence. Ensure complete sentences within the token limit.  
- Output example for "Software Developer":  
  🔹 B.Tech CSE | BSc Computer Science | M.Tech CSE | BCA | MCA  
 
### **Instructions:**  
- Generate a response that fits within 300 tokens without cutting off mid-sentence.  
- Ensure the list includes **only the most relevant educational qualifications** for the given job title.  
- Keep the response concise and structured as a list with bullet points.  `,
        ],
        courceCertificates: [
          // `Title : ${jobTitle} Question : Have you pursued any relevant courses or certifications
          //       recently?`,
          `You are an expert career assistant AI. Your task is to generate a concise and structured response for a given job title based on a specific question.  
 
**Question:** "Have you pursued any relevant courses or certificates recently?"  
**Job Title:** ${jobTitle}  
 
### **Expected Output Format:**  
- **Courses:** A list of commonly relevant courses or certifications for the given job title.  
- The response must be well-structured and should not be cut off mid-sentence. Ensure complete sentences within the token limit.  
- Output example for "Software Developer":  
  🔹 Data Structures & Algorithms (DSA) | Object-Oriented Programming (OOPs) | Database Management System (DBMS) | Operating Systems (OS) | Computer Networks (CN)  
 
### **Instructions:**  
- Generate a response that fits within 300 tokens without cutting off mid-sentence.  
- Ensure the list includes **only the most relevant courses or certifications** for the given job title.  
- Keep the response concise and formatted as a list with bullet points.  `,
        ],
        technicalSkills: [
          // `Title : ${jobTitle} Question : What technical skills or expertise do you bring to this role?`,
          `You are an expert career assistant AI. Your task is to generate a concise and structured response for a given job title based on a specific question.  
 
**Question:** "What technical skills or expertise do you bring to this role?"  
**Job Title:** ${jobTitle}
 
### **Expected Output Format:**  
- **Skills:** A list of commonly required technical skills relevant to the given job title.  
- The response must be well-structured and should not be cut off mid-sentence. Ensure complete sentences within the token limit.  
- Output example for "Software Developer":  
  🔹 Programming (Python, Java, C++) | Data Structures & Algorithms (DSA) | Database Management (SQL, NoSQL) | System Design & Architecture | Version Control (Git, GitHub)  
 
### **Instructions:**  
- Generate a response that fits within 300 tokens without cutting off mid-sentence.  
- Ensure the list includes **only the most relevant technical skills** for the given job title.  
- Keep the response concise and formatted as a list with bullet points.  `,
        ],
        deadlines: [
          `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "How do you handle stress and tight deadlines?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
        ],
        commonGoal: [
          `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "Describe a situation where you had to collaborate with a diverse team to achieve a common goal."  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
        ],
        workplace: [
          `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "Can you share an example of when you had to navigate a difficult conversation or conflict in the workplace?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
        ],
        teamMembersColleague: [
          `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "How would you describe yourself as a team member and a colleague?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
        ],
        motivates: [
          // `Title : ${jobTitle} Question : What motivates you to excel in your work?`,
          `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "What motivates you to excel in your work?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
        ],
        responsibilitiesChallenges: [
          // `Title : ${jobTitle} Question : Can you describe your ideal job in terms of responsibilities and challenges?`,
          `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "Can you describe your ideal job in terms of responsibilities and challenges?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
        ],
        projects: [
          `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "What kind of projects or tasks bring out the best in you professionally?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
        ],
        newOrganization: [
          `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "What factors are most important to you when considering a new organization?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
        ],
        companyMission: [
          `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "How do you align with our company's values and mission?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
        ],
        jobFactores: [
          `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "What factors are crucial for you when choosing a new job?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
        ],
        preferenceCultureGrowthCompensation: [
          `You are an expert career assistant AI. Your task is to generate a structured and detailed job summary based on the provided job title and relevant details. Ensure the response is clear, concise, and well-formatted.
                    **Question:** "How do you prioritize between company culture, career growth, and compensation?"  
**Job Title:** ${jobTitle} 
                  
### **Instructions:** 
- Generate a response that fits within 300 tokens without cutting off mid-sentence.
- Keep the response concise and formatted as a list with bullet points.`,
        ],
      };
      const data = (await generateTextObject(object)) as GeneratedTextResponse;
      initialData.workingHours = data?.workingHours;
      initialData.educationalBackground = data?.educationalBackground;
      initialData.courceCertificates = data?.courceCertificates;
      initialData.technicalSkills = data?.technicalSkills;
      initialData.deadlines = data?.deadlines;
      initialData.workplace = data?.workplace;
      initialData.commonGoal = data?.commonGoal;
      initialData.teamMembersColleague = data?.teamMembersColleague;
      initialData.motivates = data?.motivates;
      initialData.responsibilitiesChallenges = data?.responsibilitiesChallenges;
      initialData.projects = data?.projects;
      initialData.newOrganization = data?.newOrganization;
      initialData.companyMission = data?.companyMission;
      initialData.jobFactores = data?.jobFactores;
      initialData.preferenceCultureGrowthCompensation =
        data?.preferenceCultureGrowthCompensation;
      setAiLoading(false);
    }
  };

  const disablePastDates = (date: Dayjs) => {
    return date.isBefore(dayjs(), "day");
  };

  return (
    <div>
      <Container
        style={{
          display: "flex",
          padding: "25px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid
          spacing={2}
          bgcolor="#FFFFFF"
          width="884px"
          borderRadius="22px"
          border="1px solid #D6D6D7"
          margin={0}
        >
          <Grid
            item
            height={isMobile ? "auto" : "auto"}
            style={{ padding: 30 }}
          >
            <Grid
              container
              direction="row"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              gap={isMobile ? "10px" : ""}
            >
              <Grid item width="fit-content">
                <Typography color="#273848" fontWeight={700} fontSize="20.94px">
                  Personal Information
                </Typography>
              </Grid>
              <Grid item gap={2} display="flex">
                <Box
                  sx={{
                    width: 36,
                    height: 8,
                    borderRadius: 4,
                    bgcolor: "#84E1CC",
                  }}
                />
                <Box
                  sx={{
                    width: 36,
                    height: 8,
                    borderRadius: 4,
                    bgcolor: "#DFF4EF",
                  }}
                />
                <Box
                  sx={{
                    width: 36,
                    height: 8,
                    borderRadius: 4,
                    bgcolor: "#DFF4EF",
                  }}
                />
                <Box
                  sx={{
                    width: 36,
                    height: 8,
                    borderRadius: 4,
                    bgcolor: "#DFF4EF",
                  }}
                />
                <Box
                  sx={{
                    width: 36,
                    height: 8,
                    borderRadius: 4,
                    bgcolor: "#DFF4EF",
                  }}
                />
              </Grid>
            </Grid>
            <Grid mt="26px"></Grid>
            <Typography
              color="#273848"
              fontWeight={700}
              lineHeight="14.94px"
              fontSize="15px"
              //   className="input-label-custom"
            >
              Personal Information
            </Typography>
            <Grid mt="15px"></Grid>
            <Grid mt="20px"></Grid>
            <Grid item>
              <Typography className="input-label-custom">
                Name <span style={{ color: "red" }}>*</span>
              </Typography>
              <Grid mb="5px"></Grid>
              <TextField
                placeholder="Enter your name"
                fullWidth
                sx={{
                  // mt: 1,
                  "& .MuiOutlinedInput-input": {
                    padding: "10px 11px", // Add padding here
                  },
                }}
                className="input-box-custom"
                error={!!errors.name}
                helperText={errors.name}
                value={name}
                onChange={(e) => {
                  const value = e.target.value;
                  setName(value);
                  if (value.trim() !== "") {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      name: "",
                    }));
                  }
                }}
              />
            </Grid>
            <Grid mt="20px"></Grid>
            <Grid item>
              <Typography className="input-label-custom">
                Email <span style={{ color: "red" }}>*</span>
              </Typography>
              <Grid mb="5px"></Grid>
              <TextField
                sx={{
                  // mt: 1,
                  "& .MuiOutlinedInput-input": {
                    padding: "10px 11px", // Add padding here
                  },
                }}
                placeholder="Enter your email"
                fullWidth
                className="input-box-custom"
                error={!!errors.email}
                helperText={errors.email}
                value={email}
                onChange={(e) => {
                  const value = e.target.value;
                  setEmail(value);
                  if (value.trim() !== "") {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      email: "",
                    }));
                  }
                }}
              />
            </Grid>
            <Grid mt="20px"></Grid>
            <Grid item>
              <Typography className="input-label-custom">
                Mobile Number <span style={{ color: "red" }}>*</span>
              </Typography>
              <Grid mb="5px"></Grid>
              <TextField
                sx={{
                  // mt: 1,
                  "& .MuiOutlinedInput-input": {
                    padding: "10px 11px", // Add padding here
                  },
                }}
                placeholder="Enter your mobile number"
                fullWidth
                className="input-box-custom"
                error={!!errors.phone}
                helperText={errors.phone}
                value={phone}
                onChange={(e) => {
                  const value = e.target.value;
                  const numericValue = value.replace(/\D/g, "");

                  setPhone(numericValue);
                  if (numericValue.trim() !== "") {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      phone: "",
                    }));
                  } else {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      phone: "Mobile number is required.",
                    }));
                  }
                }}
                inputProps={{
                  maxLength: 10,
                }}
              />
            </Grid>
            <Grid mt="20px"></Grid>
            <Grid item>
              <Typography className="input-label-custom">
                Job Position <span style={{ color: "red" }}>*</span>
              </Typography>
              <Grid mb={1}></Grid>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={jobPosition}
                fullWidth
                displayEmpty
                onChange={(e) => handleCandidateJob(e)}
                renderValue={(value) => (
                  <span className={value === "" ? "placeholder" : ""}>
                    {value === "" ? "Select" : jobPositionName}
                  </span>
                )}
              >
                <MenuItem value="" disabled>
                  Select
                </MenuItem>
                {getCompanyJob.length === 0 ? (
                  <MenuItem disabled>No Jobs Available</MenuItem>
                ) : (
                  getCompanyJob?.map((job) => (
                    <MenuItem key={job.id} value={job.id}>
                      {job.jobTitle}
                    </MenuItem>
                  ))
                )}
              </Select>
              <InputLabel
                style={{
                  color: "#f44336",
                  paddingTop: "3px",
                  fontSize: "12px",
                  paddingLeft: "10px",
                }}
              >
                {errors.jobPosition}
              </InputLabel>
            </Grid>
            <Grid mt="30px"></Grid>
            <Grid
              display="flex"
              alignItems="center"
              border="1px solid #c3c3c3"
              borderRadius="8px"
              padding="8px 0px 6px 15px"
            >
              <Grid direction="row" display="flex" gap={1} alignItems="center">
                <img src={CurrentLocationIcon} alt="overview-icon" />
                <Typography
                  //   className="input-label-custom"
                  fontWeight={700}
                  fontSize="13.94px"
                  lineHeight="13.94px"
                  color="#273848"
                >
                  Current Situation & Practicalities
                </Typography>
              </Grid>
            </Grid>
            <Grid mt="30px"></Grid>
            <Typography
              color="#273848"
              fontWeight={700}
              lineHeight="14.94px"
              fontSize="15px"
              //   className="input-label-custom"
            >
              Current Situation
            </Typography>
            <Grid mt="15px"></Grid>
            <Grid item>
              <Typography
                //  color="#4E4E4E"
                //  fontWeight={500}
                //  fontSize="14px"
                className="input-label-custom"
              >
                Can you briefly describe your current role and responsibilities?{" "}
                <span style={{ color: "red" }}>*</span>
              </Typography>
              <Grid mb="5px"></Grid>
              <OutlinedInput
                placeholder="Type here..."
                multiline
                minRows={4}
                maxRows={10}
                className="text-area-size"
                value={rolesResponsibilities}
                onChange={(e) => {
                  const value = e.target.value;
                  setRolesResponsibilities(value);
                  if (value.trim() !== "") {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      rolesResponsibilities: "",
                    }));
                  }
                }}
              />
            </Grid>
            <InputLabel
              style={{
                color: "#f44336",
                paddingTop: "3px",
                fontSize: "12px",
                paddingLeft: "10px",
              }}
            >
              {errors.rolesResponsibilities}
            </InputLabel>
            <Grid mt="25px"></Grid>
            <Grid item>
              <Typography
                //  color="#4E4E4E"
                //  fontWeight={500}
                //  fontSize="14px"
                className="input-label-custom"
              >
                What prompted you to start exploring new opportunities?{" "}
                <span style={{ color: "red" }}>*</span>
              </Typography>
              <Grid mb="5px"></Grid>
              <OutlinedInput
                placeholder="Type here..."
                multiline
                minRows={4}
                maxRows={10}
                className="text-area-size"
                value={opportunities}
                onChange={(e) => {
                  const value = e.target.value;
                  setOpportunities(value);
                  if (value.trim() !== "") {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      opportunities: "",
                    }));
                  }
                }}
              />
            </Grid>
            <InputLabel
              style={{
                color: "#f44336",
                paddingTop: "3px",
                fontSize: "12px",
                paddingLeft: "10px",
              }}
            >
              {errors.opportunities}
            </InputLabel>
            <Grid mt="30px"></Grid>
            <Typography
              color="#273848"
              fontWeight={700}
              lineHeight="14.94px"
              fontSize="15px"
              //   className="input-label-custom"
            >
              Salary Indication & Benefits
            </Typography>
            <Grid mt="15px"></Grid>
            <Grid item>
              <Typography className="input-label-custom">
                What is your salary expectation for this position?{" "}
                <span style={{ color: "red" }}>*</span>
              </Typography>
              <Grid mb="5px"></Grid>
              <TextField
                sx={{
                  // mt: 1,
                  '& .css-8ewcdo-MuiInputBase-root-MuiOutlinedInput-root': {
                    padding: '12px 11px', // Add padding here
                  },
                }}
                placeholder="What is your salary expectation for this position?"
                fullWidth
                multiline
                minRows={1}
                maxRows={10}
                className="input-box-custom"
                error={!!errors.salaryExpectation}
                helperText={errors.salaryExpectation}
                value={salaryExpectation}
                onChange={(e) => {
                  const value = e.target.value;
                  setSalaryExpectation(value);
                  if (value.trim() !== "") {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      salaryExpectation: "",
                    }));
                  }
                }}
              />
            </Grid>
            <Grid mt="19px"></Grid>
            <Grid item>
              <Typography className="input-label-custom">
                Can you discuss your understanding of the salary range for this
                role? <span style={{ color: "red" }}>*</span>
              </Typography>
              <Grid mb="5px"></Grid>
              <TextField
                sx={{
                  // mt: 1,
                  '& .css-8ewcdo-MuiInputBase-root-MuiOutlinedInput-root': {
                    padding: '12px 11px', // Add padding here
                  },
                }}
                placeholder="Can you discuss your understanding of the salary range for this role?"
                fullWidth
                multiline
                minRows={1}
                maxRows={10}
                className="input-box-custom"
                error={!!errors.salaryRange}
                helperText={errors.salaryRange}
                value={salaryRange}
                onChange={(e) => {
                  const value = e.target.value;
                  setSalaryRange(value);
                  if (value.trim() !== "") {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      salaryRange: "",
                    }));
                  }
                }}
              />
            </Grid>
            <Grid mt="19px"></Grid>
            <Grid item>
              <Typography className="input-label-custom">
                Beyond salary, what other benefits are important to you in a job
                offer? <span style={{ color: "red" }}>*</span>
              </Typography>
              <Grid mb="5px"></Grid>
              <TextField
                sx={{
                  // mt: 1,
                  '& .css-8ewcdo-MuiInputBase-root-MuiOutlinedInput-root': {
                    padding: '12px 11px', // Add padding here
                  },
                }}
                placeholder="Beyond salary, what other benefits are important to you in a job
                offer?"
                fullWidth
                multiline
                minRows={1}
                maxRows={10}
                className="input-box-custom"
                error={!!errors.jobBenifits}
                helperText={errors.jobBenifits}
                value={jobBenifits}
                onChange={(e) => {
                  const value = e.target.value;
                  setJobBenifits(value);
                  if (value.trim() !== "") {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      jobBenifits: "",
                    }));
                  }
                }}
              />
            </Grid>
            <Grid mt="30px"></Grid>
            <Typography
              color="#273848"
              fontWeight={700}
              lineHeight="14.94px"
              fontSize="15px"
              //   className="input-label-custom"
            >
              Salary Indication & Benefits
            </Typography>
            <Grid mt="18px"></Grid>
            <Grid item>
              <Typography className="input-label-custom">
                When would you be available to start if an offer is extended?{" "}
                <span style={{ color: "red" }}>*</span>
              </Typography>
              <Grid mb="5px"></Grid>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Select Date"
                  sx={{ mt: 2 }}
                  value={startExtended}
                  onChange={(date: Dayjs | null) => setStartExtended(date)}
                  shouldDisableDate={disablePastDates}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid mt="18px"></Grid>
            <Grid item>
              <Typography className="input-label-custom">
                Are there any potential obstacles or commitments that might
                affect your start date? <span style={{ color: "red" }}>*</span>
              </Typography>
              <Grid mb="5px"></Grid>
              <TextField
                sx={{
                  // mt: 1,
                  '& .css-8ewcdo-MuiInputBase-root-MuiOutlinedInput-root': {
                    padding: '12px 11px', // Add padding here
                  },
                }}
                placeholder="Are there any potential obstacles or commitments that might affect your start date?"
                fullWidth
                multiline
                minRows={1}
                maxRows={10}
                className="input-box-custom"
                error={!!errors.commitments}
                helperText={errors.commitments}
                value={commitments}
                onChange={(e) => {
                  const value = e.target.value;
                  setCommitments(value);
                  if (value.trim() !== "") {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      commitments: "",
                    }));
                  }
                }}
              />
            </Grid>
            <Grid mt="42px"></Grid>
            <Grid
              container
              direction="row"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid xs={2}></Grid>
              <Grid
                item
                xs={isTabs ? 0 : mode ? 3 : 2}
                style={{ maxWidth: "fitContent" }}
              >
                <button
                  type="submit"
                  className="user-scale"
                  // variant="contained"
                  // fullWidth
                  style={{
                    backgroundColor: "#84E1CC",
                    boxShadow: "none",
                    borderRadius: "5px",
                    padding: "17px 17px",
                    lineHeight: "0px",
                    letterSpacing: "0px",
                    textTransform: "none",
                    color: "white",
                    width: "100%",
                    border: "none",
                  }}
                  onClick={(event) => handleSubmit(event)}
                >
                  {mode ? (
                    loading ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      "Save & Next"
                    )
                  ) : (
                    "Continue"
                  )}
                </button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <ConfirmationDialog
          open={openDialog}
          onConfirm={handleDialogConfirm}
          onCancel={handleDialogCancel}
          title="Confirmation"
          message="A similar Candidate Job Posotion Already Exists. Do you want to use the details of the existing candidate?"
          cancelButtonName="Cancel"
          confirmButtonName="Confirm"
        />
      </Container>
      <LoadingOverlay loading={aiLoading} />
    </div>
  );
};

export default CandidateSpeFirst;
